import { generateConditions } from 'modules/racersTable/derivations';

import { wavesStore, classesStore, squadsStore, registrationFieldsStore } from '../../stores';

const {
  generateIsClasses,
  generateIsWaves,
  generateIsSquads,
  isAnyDistanceHasWaves,
  isAnyDistanceHasSquads,
  isAnyDistanceHasClasses,
  generateIsFieldSelected,
  generateIsAnyDistanceFieldSelected,
} = generateConditions(wavesStore, classesStore, squadsStore, registrationFieldsStore);

export {
  generateIsWaves,
  generateIsClasses,
  generateIsSquads,
  isAnyDistanceHasWaves,
  isAnyDistanceHasClasses,
  isAnyDistanceHasSquads,
  generateIsAnyDistanceFieldSelected,
  generateIsFieldSelected,
};
export * from './generateIsCheckpoints';
export * from './isVirtual';
export * from './isShowAll';
export * from './isAllFiltersAreShowed';
